// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2q-2";
export var placeholderIcon = "_2q-3";
export var thumbnailCanvas = "_2q-1";
export var thumbnailWrapper = "_2q-0";